import React from 'react';
import partial from 'lodash/partial';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import t from '@instructure/quiz-i18n/es/format-message';
var propsForVersioningWrapper = function propsForVersioningWrapper(copyDescription, immutableDescription, isImmutable, shouldClone, setShouldClone, switchOffEditing, isEditing) {
  var alertType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'warning';
  var defaultProps = {
    disableChildren: false,
    showAlert: false
  };
  if (!isEditing) return {
    showAlert: false
  };
  if (isImmutable && shouldClone) {
    Object.assign(defaultProps, {
      description: copyDescription,
      hideActions: true,
      showAlert: true
    });
  } else if (isImmutable) {
    Object.assign(defaultProps, {
      alertType: alertType,
      cancelActionCallback: switchOffEditing,
      defaultActionCallback: partial(setShouldClone, true),
      defaultActionText: t('Edit a Copy'),
      description: immutableDescription,
      disableChildren: true,
      showAlert: true
    });
  }
  return defaultProps;
};
export var propsForItemVersioningWrapper = function propsForItemVersioningWrapper() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return propsForVersioningWrapper.apply(void 0, [/*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Editing a copy.')), "\xA0", t('Item statistics from this new copy will appear separate from the previous version of this question.')), /*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Some students have already submitted answers for this question!')), "\xA0", t('You can apply your edits to a copy of this question' + ' which will only be seen by students that have not taken the assessment.'))].concat(args));
};
export var propsForStimulusVersioningWrapper = function propsForStimulusVersioningWrapper() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return propsForVersioningWrapper.apply(void 0, [/*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Editing a copy.')), "\xA0", t('Statistics from this new copy will appear separate from the previous version.')), /*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Some students have already submitted answers for this stimulus!')), "\xA0", t('You can apply your edits to a copy of this stimulus' + ' which will only be seen by students that have not taken the assessment.' + ' Attached questions will be copied as well.'))].concat(args));
};
export var propsForBankEntryVersioningWrapper = function propsForBankEntryVersioningWrapper() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return propsForVersioningWrapper.apply(void 0, [/*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Editing a copy.')), "\xA0", t('Statistics from this new copy will appear separate from the previous version of this question.')), /*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, t('This item has been deleted from the item bank. Students will still see it on future attempts. To edit, make a copy of the item.'))].concat(args));
};
export var propsForBankEntryEditPrompt = function propsForBankEntryEditPrompt(isEditing, switchOffEditing, defaultActionCallback, description) {
  if (!isEditing) return {
    showAlert: false
  };
  return {
    cancelActionCallback: switchOffEditing,
    disableChildren: true,
    description: description,
    defaultActionCallback: defaultActionCallback,
    defaultActionText: t('Edit in Bank'),
    showAlert: true
  };
};
export var propsForItemBankEntryEditPrompt = function propsForItemBankEntryEditPrompt() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  return propsForBankEntryEditPrompt.apply(void 0, args.concat([/*#__PURE__*/React.createElement(Text, {
    color: "primary"
  }, /*#__PURE__*/React.createElement("b", null, t('Banked Item.')), "\xA0", t('Some options and the points value can be changed here but editing must take place within the bank.'))]));
};
export var propsForStimulusBankEntryEditPrompt = function propsForStimulusBankEntryEditPrompt() {
  var isPassage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var title = isPassage ? t('Banked Passage.') : t('Banked Stimulus.');
  var content = isPassage ? t('Editing of this passage must take place within the bank.') : t('Editing of this stimulus must take place within the bank.');
  var promptComponent = /*#__PURE__*/React.createElement(View, {
    as: "div",
    "data-automation": "sdk-editInBanks-warning"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(View, {
    margin: "0 0 0 xx-small"
  }, /*#__PURE__*/React.createElement(Text, null, content)));
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  return propsForBankEntryEditPrompt.apply(void 0, args.concat([promptComponent]));
};
export var propsForBankEntryUnauthorizedEdit = function propsForBankEntryUnauthorizedEdit(isEditing) {
  if (!isEditing) return {
    showAlert: false
  };
  return {
    alertType: 'warning',
    disableChildren: true,
    description: /*#__PURE__*/React.createElement(Text, {
      color: "primary"
    }, /*#__PURE__*/React.createElement("b", null, t('Banked Item.')), "\xA0", t("You don't have the needed permissions to edit.")),
    hideActions: true,
    showAlert: true
  };
};